import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { GraphqlService } from '../../../../common/services/graphql.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NavigationEnd, Router } from '@angular/router';
import { CommonDataService } from '../../../../common/services/common-data.service';
import { Title } from '@angular/platform-browser';
import { LoginService } from '../../../../common/services/Login.service';
import { SessionService } from '../../../../common/services/Session.service';
import { filter } from 'rxjs/operators';
import scrollIntoView from 'scroll-into-view-if-needed'

interface LeftNav {
  item: string;
  itemLink?: string;
  itemData?: LeftNav[];
  logoSrc: string;
  spaceOnBottom: boolean;
  spaceOnTop: boolean;
  isSecContent: boolean;
  afterShowAllInOnePageRequiredIfSECHides: boolean;
  afterShowAllInOnePageRequired: boolean;
  isShowAllInOnePageNotRequired: boolean;
  isIndustryChanged: boolean;
  archiveList: string;
  navPath: string;
}

@Component({
  selector: 'app-table-of-content',
  templateUrl: './table-of-content.component.html',
  styleUrls: ['./table-of-content.component.css']
})
export class TableOfContentComponent implements OnInit, AfterViewChecked {
  outcome: boolean = false;

  breadcrumb: string[] = [];
  navData = {
    crumbData: [],
    menuData: [],
  };
  @ViewChild('tree') tree;
  treeControl = new NestedTreeControl<LeftNav>(node => node.itemData);
  dataSource = new MatTreeNestedDataSource<LeftNav>();
  navPathData: any[] = [];
  treeRendered = false;
  IsGlossary:boolean;
  constructor(private graphQlService: GraphqlService, private router: Router, private commonDataService: CommonDataService, private browserTitle: Title, private loginService: LoginService, private session: SessionService, private cdr: ChangeDetectorRef
  ) { }
  hasChild = (_: number, node: LeftNav) => !!node.itemData && node.itemData != null;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.glossaryTermFromContentPageBackButton.subscribe(glossaryTerm=>{
      this.IsGlossary = glossaryTerm != "" && glossaryTerm != undefined ? true : false;
    })
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    this.starting = false;
    if (leftNavigation == undefined || leftNavigation == null) {
      this.graphQlService.getNavPathTree(this.router.url.split("/")[1]).subscribe(data => { this.navPathData = data; });
    }
    else {
      this.navPathData = this.getBreadcrumbWithNavPath(this.router.url?.split("/")[1]);
    }

    this.dataSource.data = this.navPathData;
    this.treeControl.dataNodes = this.navPathData;
    this.treeControl.expandAll();
    this.treeRendered = true;

    this.commonDataService.showSecContent.subscribe(data => {
      if (data === true) {
        if (this.navPathData.length > 0 && this.navPathData[0].itemData.length > 0) {
          this.dataSource.data = null;
          this.dataSource.data = this.navPathData;
          this.treeControl.dataNodes = this.navPathData;
          this.treeControl.expandAll();
        }
      }
      else {
        if (this.navPathData.length > 0 && this.navPathData[0].itemData.length > 0) {
          let navPathDataWithoutSec = JSON.parse(JSON.stringify(this.navPathData));

          if (!navPathDataWithoutSec[0].itemData[0].itemData) {
            navPathDataWithoutSec[0].itemData = navPathDataWithoutSec[0].itemData.filter(x => x.item[0] !== 'S');
          }
          else {
            let dataLength1 = navPathDataWithoutSec[0].itemData.length;
            for (let i = 0; i < dataLength1; i++) {
              navPathDataWithoutSec[0].itemData[i].itemData = navPathDataWithoutSec[0].itemData[i].itemData.filter(x => x.item[0] !== 'S');
            }
          }

          this.dataSource.data = null;
          this.dataSource.data = navPathDataWithoutSec;
          this.treeControl.dataNodes = navPathDataWithoutSec;
          this.treeControl.expandAll();
        }
      }
    });

    this.navData.crumbData = this.navPathData[0]?.navPath?.split("---");
    let crummData = this.navData.crumbData[1].includes("X") ? this.navData.crumbData[2].substring(0, 3) + "-" + this.navData.crumbData[3] : this.navData.crumbData[1].substring(0, 3) + "-" + this.navData.crumbData[2];
    let title = this.router.url.split("/")[1].split("-").length > 1 ? crummData : this.navPathData[0].item;
    this.browserTitle.setTitle(title); this.outcome = true;
    this.commonDataService.showLoader.next(false);
    this.event$
      = this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
      .subscribe(() => {
        this.outcome = false;
        this.commonDataService.showLoader.next(true);
        this.starting = false;
        leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (leftNavigation == undefined || leftNavigation == null) {
          this.graphQlService.getNavPathTree(this.router.url.split("/")[1]).subscribe(data => { this.navPathData = data; });
        }
        else {
          this.navPathData = this.getBreadcrumbWithNavPath(this.router.url.split("/")[1]);
        }
        this.dataSource.data = this.navPathData; this.treeControl.dataNodes = this.navPathData;
        this.navData.crumbData = this.navPathData[0]?.navPath?.split("---");
        crummData = this.navData?.crumbData[1]?.includes("X") ? this.navData?.crumbData[2]?.substring(0, 3) + "-" + this.navData?.crumbData[3] : this.navData?.crumbData[1]?.substring(0, 3) + "-" + this.navData?.crumbData[2];
        title = this.router.url.split("/")[1]?.split("-").length > 1 ? crummData : this.navPathData[0]?.item;
        this.browserTitle.setTitle(title); this.outcome = true;
        this.commonDataService.showLoader.next(false);
      });
  }

  setFocus(){
    if( document.getElementById("tableOfContents")!=null){
     let node= document.getElementById("tableOfContents")
      setTimeout(() => {
        scrollIntoView(node, {
          scrollMode: 'always',
          block: 'start',
          inline: 'start',
          boundary: document.getElementsByTagName('app-main-content')[0]
        })
      }, 500);
    }
  }

  ngAfterViewInit(){
    this.setFocus();
  }
  event$
  starting: boolean = false;

  ngAfterViewChecked(): void {
    if (!this.starting) {
      if (this.tree != null && this.tree.treeControl != null) {
        this.tree.treeControl.expandAll();
      }
      this.cdr.detectChanges();
      this.starting = true;
      if (!this.treeRendered) {
        this.updateSEClinksOnPageNavDataUpdate();
      }
      else {
        this.treeRendered = false;
      }
    }
  }

  navigateToUrl(url: string) {
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    this.router.navigateByUrl(url);
  }
  /* Start -- Hyperlink Topic and Subtopic FPP-38 */
  navigateToUrlSubTopics(url) {
    if (url.navPath.includes("---")) {
      if (url.navPath.split("---")[1].split(" ")[0] === url.item.split(" ")[0]) {
        this.router.navigateByUrl(url.item.split(" ")[0] + '/showallinonepage');
      }
      else {
        this.router.navigateByUrl(url.navPath.split("---")[1].split(" ")[0] + '/' + url.item.split(" ")[0] + '/showallinonepage');
      }
    } else {
    this.router.navigateByUrl(url.navPath.split("-")[0] + '/'+url.navPath.split("-")[1] + '/showallinonepage');      
    }
  }
  /* End -- Hyperlink Topic and Subtopic FPP-38 */
  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any, pageName: string }[] = [];
  pagepubllist: { sectionarray: object[], sectionname: string, mainsectionname: string }[] = [];
  mainsection: string = "";

  JoinAllSubtopicsIncludingSharedSubtopics() {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    this.mainsection = this.navData.crumbData[1];
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    if (this.mainsection.split(" ")[0].includes("X")) {
      this.mainsection = this.navData.crumbData[2];
    }
    this.getpagepublidsIncludingSharedSubtopics(this.navPathData[0]);
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
    if (this.mainsection.split(" ")[0] != this.navPathData[0].item.split(" ")[0]) {
      let url = this.mainsection.split(" ")[0] + '/' + this.navPathData[0].item.split(" ")[0] + '/showallinonepageplus';
      this.router.navigateByUrl(url);
    } else {
      let url = this.mainsection.split(" ")[0] + '/showallinonepageplus';
      this.router.navigateByUrl(url);
    }
  }

  getpagepublidsIncludingSharedSubtopics(obj) {
    if (obj.itemData != null) {
      for (let items of obj.itemData) {
        this.getpagepublidsIncludingSharedSubtopics(items);
      }
    }
    if (obj.itemLink != null) {
      if (obj.itemLink.length > 0) {
        let PublpageId = obj.itemLink.split('/').map(d => d);
        obj.navPath = obj.navPath.split("-")
        if (obj.navPath[0].includes("X")) {
          obj.navPath = obj.navPath.slice(1, obj.navPath.length);
        }
        let pageTitle = obj.navPath.join("-");
        if (!obj.navPath[obj.navPath.length - 1].includes("75")) {
          this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageName: obj.item });
        }
      }
    }
    else {
      if (this.pagepublicationId.length > 0) {

        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }

  JoinAllSubtopics() {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    this.mainsection = this.navData.crumbData[1];
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    if (this.mainsection.split(" ")[0].includes("X")) {
      this.mainsection = this.navData.crumbData[2];
    }
    this.getpagepublids(this.navPathData[0]);
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
    if (this.mainsection.split(" ")[0] != this.navPathData[0].item.split(" ")[0]) {
      let url = this.mainsection.split(" ")[0] + '/' + this.navPathData[0].item.split(" ")[0] + '/showallinonepage';
      this.router.navigateByUrl(url);
    } else {
      let url = this.mainsection.split(" ")[0] + '/showallinonepage';
      this.router.navigateByUrl(url);
    }
  }

  getpagepublids(obj) {
    if (obj.itemData != null) {
      for (let items of obj.itemData) {
        this.getpagepublids(items);
        if (items.afterShowAllInOnePageRequired) {
          break;
        }
      }
    }
    if (obj.itemLink != null) {
      if (obj.itemLink.length > 0) {
        let PublpageId = obj.itemLink.split('/').map(d => d);
        obj.navPath = obj.navPath.split("-")
        if (obj.navPath[0].includes("X")) {
          obj.navPath = obj.navPath.slice(1, obj.navPath.length);
        }
        let pageTitle = obj.navPath.join("-");
        //let pageTitle = PublpageId[2].replace(PublpageId[2].split(" ")[0], obj.navPath);
        if (!obj.navPath[obj.navPath.length - 1].includes("75")) {
          this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageName: obj.item });
        }
      }
    }
    else {
      if (this.pagepublicationId.length > 0) {

        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }

  updateSEClinksOnPageNavDataUpdate() {
    if (localStorage.getItem("DefaultSecView") === "false") {
      let navPathDataWithoutSec = JSON.parse(JSON.stringify(this.navPathData));

      if (navPathDataWithoutSec[0]?.itemData[0]?.itemData === null) {
        navPathDataWithoutSec[0].itemData = navPathDataWithoutSec[0].itemData.filter(x => x.item[0] !== 'S');
      }
      else {
        let dataLength1 = navPathDataWithoutSec[0]?.itemData?.length;
        for (let i = 0; i < dataLength1; i++) {
          navPathDataWithoutSec[0].itemData[i].itemData = navPathDataWithoutSec[0].itemData[i].itemData.filter(x => x.item[0] !== 'S');
        }
      }
      this.dataSource.data = null;
      this.dataSource.data = navPathDataWithoutSec;
      this.treeControl.dataNodes = navPathDataWithoutSec;
      this.treeControl.expandAll();
    }
    else {
    this.dataSource.data = null;
    this.dataSource.data = this.navPathData;
    this.treeControl.dataNodes = this.navPathData;
    this.treeControl.expandAll();
    }
  }

  BreadcrumbData: any[] = [];
  getBreadcrumbWithNavPath(breadcerumbUrl) {
    this.BreadcrumbData = [];
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    //Added by Sagar
    this.pageNumsForCount = breadcerumbUrl;
    //End
    for (let i = 0; i < leftNavigation.length; i++) {
      if (leftNavigation[i].itemData != null) {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            leftNavigation[i].itemData[j].navPath = leftNavigation[i].item + "---" + leftNavigation[i].itemData[j].item;
            this.BreadcrumbData.push(leftNavigation[i].itemData[j]);
            return this.BreadcrumbData;
          } else {
            if (leftNavigation[i].itemData[j].itemData != null) {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  leftNavigation[i].itemData[j].itemData[k].navPath = leftNavigation[i].item + "---" + leftNavigation[i].itemData[j].item + "---" + leftNavigation[i].itemData[j].itemData[k].item;
                  this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k]);
                  return this.BreadcrumbData;
                } else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        leftNavigation[i].itemData[j].itemData[k].itemData[l].navPath = leftNavigation[i].item + "---" + leftNavigation[i].itemData[j].item + "---" + leftNavigation[i].itemData[j].itemData[k].item + "---" + leftNavigation[i].itemData[j].itemData[k].itemData[l].item;
                        this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l]);
                        return this.BreadcrumbData;
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].navPath = leftNavigation[i].item + "---" + leftNavigation[i].itemData[j].item + "---" + leftNavigation[i].itemData[j].itemData[k].item + "---" + leftNavigation[i].itemData[j].itemData[k].itemData[l].item + "---" + leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item;
                              this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]);
                              return this.BreadcrumbData;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return [];
  }
  pageNumsForCount: string = "";
  OpenWhatLinksHere() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.whatLinksHereParams.next(this.pageNumsForCount);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("What Links Here");
    this.commonDataService.hasSecContent.next(false);
    this.commonDataService.hasActualContent.next(false);
    this.commonDataService.invokedFromTOC.next(true);
  }
}
